module.exports = __webpack_public_path__ + "media/prt/bghead-7b10d090.png";